

















































    import Vue from 'vue';
    import {Component, Prop, Provide} from "vue-property-decorator";

    const logo = require('../../public/img/logo_100x100.gif');
    const logo_lc = require('../../public/img/logo_lacentrale_3.png');

    @Component
    export default class HeaderC extends Vue {

        @Provide()
        logoSrc = logo;

        @Provide()
        logoLC = logo_lc;

//        @Prop()
//        value: string;
//
//        @Prop()
//        onClick?: () => void;
//
//        @Provide()
//        msg: number = 1234;
//
//        @Provide()
//        helloMsg = 'Hello, ' + this.propMessage;
//
//        // lifecycle hook
//        mounted() {
//            this.greet();
//        }
//
//        // computed
//        get computedMsg() {
//            return 'computed ' + this.msg;
//        }
//
//        // method
//        greet() {
//            console.log('greeting: ' + this.msg);
//        }
    }




// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/HeaderC.vue